import { render, staticRenderFns } from "./dydp_manage_media.vue?vue&type=template&id=6c44871e&scoped=true"
import script from "./dydp_manage_media.vue?vue&type=script&lang=js"
export * from "./dydp_manage_media.vue?vue&type=script&lang=js"
import style0 from "./dydp_manage_media.vue?vue&type=style&index=0&id=6c44871e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44871e",
  null
  
)

export default component.exports